// Reads the active company exposed by the blade (<meta name="companyId">) to
// scope the active-conversation pointer in localStorage. Each company remembers
// its own last opened conversation.
export function currentCompanyId() {
  return document.querySelector('meta[name="companyId"]')?.getAttribute('content') || 'unknown';
}

export function activeConversationKey() {
  return `creative-studio:active-conversation-id:${currentCompanyId()}`;
}

// Sentinel stored as the pointer value when the user explicitly starts a new
// (blank) chat. On reload it keeps the chat blank instead of falling back to the
// company's most recent conversation.
export const NEW_CHAT_POINTER = 'new';
